import { render, staticRenderFns } from "./randomCard.vue?vue&type=template&id=1f2ab64d&scoped=true&"
import script from "./randomCard.vue?vue&type=script&lang=js&"
export * from "./randomCard.vue?vue&type=script&lang=js&"
import style0 from "./randomCard.vue?vue&type=style&index=0&id=1f2ab64d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ab64d",
  null
  
)

export default component.exports